import { sendPasswordResetEmail } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import { auth, functions } from "../firebase";

const call = (name) => httpsCallable(functions, name);

export async function createStaffUserAccount(staff) {
  const result = await call("createStaffUser")({ staff });
  if (staff?.email) await sendPasswordResetEmail(auth, String(staff.email).trim().toLowerCase());
  return result.data;
}

export async function updateStaffUserAccount(staffId, staff) {
  const result = await call("updateStaffUser")({ staffId, staff });
  return result.data;
}

export async function setStaffUserActive(staffId, isActive, leavingDate = "") {
  const result = await call("setStaffUserActive")({ staffId, isActive, leavingDate });
  return result.data;
}

export async function sendStaffResetEmail(email) {
  await sendPasswordResetEmail(auth, String(email || "").trim().toLowerCase());
}

export async function createClientPortalAccount({ clientId, email, name }) {
  const result = await call("createClientPortalUser")({ clientId, email, name });
  await sendPasswordResetEmail(auth, String(email).trim().toLowerCase());
  return result.data;
}

export async function setClientPortalAccountActive(clientId, isActive) {
  const result = await call("setClientPortalUserActive")({ clientId, isActive });
  return result.data;
}

export async function sendClientPortalResetEmail(email) {
  await sendPasswordResetEmail(auth, String(email || "").trim().toLowerCase());
}

export async function recordClientLogin() {
  const result = await call("recordClientLogin")({});
  return result.data;
}
